import React, { useEffect, useState } from "react";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";

const MyTDSCertificate = () => {
  const [loading, setLoading] = useState(true);
  const [getTDSPdfData, setGetTDSPdfData] = useState([]);
  const [pageLoading, setPageLoading] = useState("");
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("My TDS Certificate"));
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await GetServiceCaller(
        `${API_URL}payroll/finance/mytdscertificate`
      );

      if (response.status === 200) {
        setPageLoading(response.status);
        const cleanedData = response?.data?.data || [];
        setGetTDSPdfData(cleanedData);
      } else {
        setError("Failed to fetch data. Please try again.");
        toast.error("Failed to fetch TDS certificates");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("An error occurred while fetching data.");
      toast.error("An error occurred while fetching TDS certificates");
    } finally {
      setLoading(false);
    }
  };

  const handlePdfRender = (ele) => {
    if (!ele?.FilePath) {
      toast.warning("No PDF file available");
      return;
    }
    setSelectedPdf(ele.FilePath);
  };

  const closeModal = () => {
    setSelectedPdf(null);
  };

  return (
    <div className="container-fluid" id="skill_section">
      <div className="container-fluid" id="skill-table-area">
        {loading ? (
          <div
            className="text-center py-5"
            style={{
              minHeight: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div>
              <FaSpinner
                className="spinner"
                spin
                style={{
                  fontSize: "2rem",
                  color: "#2E2E48",
                  marginBottom: "10px",
                }}
              />
              <p style={{ color: "#7f8c8d", marginTop: "10px" }}>
                Loading your certificates...
              </p>
            </div>
          </div>
        ) : error ? (
          <div
            className="alert alert-danger"
            style={{
              background: "#f8d7da",
              color: "#721c24",
              border: "1px solid #f5c6cb",
              borderRadius: "8px",
              padding: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span>{error}</span>
            <button
              className="btn btn-sm btn-outline-danger ms-2"
              onClick={fetchData}
              style={{
                borderColor: "#dc3545",
                color: "#dc3545",
                borderRadius: "4px",
                padding: "5px 10px",
                fontSize: "0.875rem",
              }}
            >
              Retry
            </button>
          </div>
        ) : getTDSPdfData?.length > 0 ? (
          <div className="row g-3">
            {getTDSPdfData.map((ele, index) => {
              const isHovered = hoveredIndex === index;

              return (
                <div
                  className="col-md-3 col-sm-6"
                  key={index}
                  style={{ padding: "5px" }}
                >
                  <div
                    onClick={() => handlePdfRender(ele)}
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    style={{
                      cursor: "pointer",
                      border: isHovered
                        ? "2px solid #3498db"
                        : "1px solid #e0e0e0",
                      borderRadius: "8px",
                      background: "#ffffff",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                      padding: "5px",
                      textAlign: "center",
                      transition: "all 0.3s ease",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    {/* Inline File SVG Icon */}
                    <div style={{ marginBottom: "12px" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#3498db"
                          d="M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
                        />
                        <path
                          fill="#fff"
                          d="M14 2v6h6M8 13h8v1H8v-1zm0 3h8v1H8v-1z"
                        />
                      </svg>
                    </div>

                    {/* File Name */}
                    <p
                      style={{
                        color: "#2c3e50",
                        marginBottom: "6px",
                        fontWeight: "500",
                        fontSize: "1rem",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      title={ele?.FileName}
                    >
                      {ele?.FileName || "Untitled Document"}
                    </p>

                    {/* File Date */}
                    {ele?.FileDate && (
                      <small
                        style={{
                          color: "#95a5a6",
                          fontSize: "0.8rem",
                          display: "block",
                        }}
                      >
                        {new Date(ele.FileDate).toLocaleDateString()}
                      </small>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div
            className="text-center py-1"
            style={{
              minHeight: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div>
              <p style={{ color: "#7f8c8d", marginBottom: "0px" }}>
                No TDS certificates are available at the moment.
              </p>
            </div>
          </div>
        )}
      </div>

      {/* PDF Modal */}
      {selectedPdf && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content">
              <div
                className="modal-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #f0f0f0",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px 8px 0 0",
                  padding: "12px 16px",
                }}
              >
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#27568B",
                    margin: "0",
                  }}
                >
                  TDS Certificate
                </p>
                <button
                  onClick={closeModal}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#000",
                    padding: "4px",
                    borderRadius: "4px",
                    transition: "all 0.2s",
                    lineHeight: "1",
                  }}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
              <div className="modal-body p-0">
                <iframe
                  src={selectedPdf}
                  width="100%"
                  height="700px"
                  title="PDF Preview"
                  style={{ border: "none" }}
                ></iframe>
              </div>
              <div className="modal-footer">
                <button className="cancel-btn" onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyTDSCertificate;
